/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { RadioboxFieldFromJSON, RadioboxFieldToJSON, } from './RadioboxField';
import { StringFieldFromJSON, StringFieldToJSON, } from './StringField';
/**
 * Check if a given object implements the CommonSection interface.
 */
export function instanceOfCommonSection(value) {
    let isInstance = true;
    return isInstance;
}
export function CommonSectionFromJSON(json) {
    return CommonSectionFromJSONTyped(json, false);
}
export function CommonSectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'codicePratica': !exists(json, 'codicePratica') ? undefined : StringFieldFromJSON(json['codicePratica']),
        'dataContratto': !exists(json, 'dataContratto') ? undefined : StringFieldFromJSON(json['dataContratto']),
        'luogoFirma': !exists(json, 'luogoFirma') ? undefined : StringFieldFromJSON(json['luogoFirma']),
        'dataContrattoGiorno': !exists(json, 'dataContrattoGiorno') ? undefined : StringFieldFromJSON(json['dataContrattoGiorno']),
        'dataContrattoMese': !exists(json, 'dataContrattoMese') ? undefined : StringFieldFromJSON(json['dataContrattoMese']),
        'dataContrattoAnno': !exists(json, 'dataContrattoAnno') ? undefined : StringFieldFromJSON(json['dataContrattoAnno']),
        'isMicroimpresaYes': !exists(json, 'isMicroimpresaYes') ? undefined : RadioboxFieldFromJSON(json['isMicroimpresaYes']),
        'isMicroimpresaNo': !exists(json, 'isMicroimpresaNo') ? undefined : RadioboxFieldFromJSON(json['isMicroimpresaNo']),
        'isMailCommunicationYes': !exists(json, 'isMailCommunicationYes') ? undefined : RadioboxFieldFromJSON(json['isMailCommunicationYes']),
        'isMailCommunicationNo': !exists(json, 'isMailCommunicationNo') ? undefined : RadioboxFieldFromJSON(json['isMailCommunicationNo']),
        'isSmsCommunicationYes': !exists(json, 'isSmsCommunicationYes') ? undefined : RadioboxFieldFromJSON(json['isSmsCommunicationYes']),
        'isSmsCommunicationNo': !exists(json, 'isSmsCommunicationNo') ? undefined : RadioboxFieldFromJSON(json['isSmsCommunicationNo']),
        'isPhoneCommunicationYes': !exists(json, 'isPhoneCommunicationYes') ? undefined : RadioboxFieldFromJSON(json['isPhoneCommunicationYes']),
        'isPhoneCommunicationNo': !exists(json, 'isPhoneCommunicationNo') ? undefined : RadioboxFieldFromJSON(json['isPhoneCommunicationNo']),
        'isEmailCommunicationYes': !exists(json, 'isEmailCommunicationYes') ? undefined : RadioboxFieldFromJSON(json['isEmailCommunicationYes']),
        'isEmailCommunicationNo': !exists(json, 'isEmailCommunicationNo') ? undefined : RadioboxFieldFromJSON(json['isEmailCommunicationNo']),
        'abiBancaBuffetti': !exists(json, 'abiBancaBuffetti') ? undefined : StringFieldFromJSON(json['abiBancaBuffetti']),
        'intestatarioBancaBuffetti': !exists(json, 'intestatarioBancaBuffetti') ? undefined : StringFieldFromJSON(json['intestatarioBancaBuffetti']),
    };
}
export function CommonSectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'codicePratica': StringFieldToJSON(value.codicePratica),
        'dataContratto': StringFieldToJSON(value.dataContratto),
        'luogoFirma': StringFieldToJSON(value.luogoFirma),
        'dataContrattoGiorno': StringFieldToJSON(value.dataContrattoGiorno),
        'dataContrattoMese': StringFieldToJSON(value.dataContrattoMese),
        'dataContrattoAnno': StringFieldToJSON(value.dataContrattoAnno),
        'isMicroimpresaYes': RadioboxFieldToJSON(value.isMicroimpresaYes),
        'isMicroimpresaNo': RadioboxFieldToJSON(value.isMicroimpresaNo),
        'isMailCommunicationYes': RadioboxFieldToJSON(value.isMailCommunicationYes),
        'isMailCommunicationNo': RadioboxFieldToJSON(value.isMailCommunicationNo),
        'isSmsCommunicationYes': RadioboxFieldToJSON(value.isSmsCommunicationYes),
        'isSmsCommunicationNo': RadioboxFieldToJSON(value.isSmsCommunicationNo),
        'isPhoneCommunicationYes': RadioboxFieldToJSON(value.isPhoneCommunicationYes),
        'isPhoneCommunicationNo': RadioboxFieldToJSON(value.isPhoneCommunicationNo),
        'isEmailCommunicationYes': RadioboxFieldToJSON(value.isEmailCommunicationYes),
        'isEmailCommunicationNo': RadioboxFieldToJSON(value.isEmailCommunicationNo),
        'abiBancaBuffetti': StringFieldToJSON(value.abiBancaBuffetti),
        'intestatarioBancaBuffetti': StringFieldToJSON(value.intestatarioBancaBuffetti),
    };
}
